import { render, staticRenderFns } from "./ClientLayout.vue?vue&type=template&id=35d8d7b7&scoped=true"
import script from "./ClientLayout.vue?vue&type=script&lang=js"
export * from "./ClientLayout.vue?vue&type=script&lang=js"
import style0 from "./ClientLayout.vue?vue&type=style&index=0&id=35d8d7b7&prod&scoped=true&lang=css"
import style1 from "./ClientLayout.vue?vue&type=style&index=1&id=35d8d7b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d8d7b7",
  null
  
)

export default component.exports